/** Minutes since midnight for a `"hh:mm AM"` value; null when blank or half-typed. */
export const parseTime12ToMinutes = (
  value?: string | null,
): number | null => {
  if (typeof value !== 'string') return null;

  const match = /^(\d{1,2}):(\d{2})\s*([AP]M)$/i.exec(value.trim());
  if (!match) return null;

  const hour = Number(match[1]);
  const minute = Number(match[2]);

  if (hour < 1 || hour > 12 || minute < 0 || minute > 59) return null;

  // `hour % 12` folds 12 to 0, which is what both meridiems need before the PM offset.
  const hour24 = (hour % 12) + (match[3].toUpperCase() === 'PM' ? 12 : 0);

  return hour24 * 60 + minute;
};

/**
 * True unless both times are complete and `to` is not later than `from`.
 * A blank or half-typed side is the incomplete-day case, which this rule leaves alone.
 */
export const officeHoursRangeIsValid = (
  from?: string | null,
  to?: string | null,
): boolean => {
  const fromMinutes = parseTime12ToMinutes(from);
  const toMinutes = parseTime12ToMinutes(to);

  if (fromMinutes === null || toMinutes === null) return true;

  return toMinutes > fromMinutes;
};
